import './ProjectItemSkeleton.scss';

const ProjectItemSkeleton = ({ position = 'right' }) => {
  const positionClass = position === 'right' ? 'right' : 'left';

  return (
    <div className="pro__items__skeleton">
      <div className={`project__item__skeleton ${positionClass}`}>
        <div className="project__item__bg__image__skeleton">
          <div className="project__item__image__skeleton">
          </div>
        </div>
        <div className="project__item__container__skeleton">
          <div className="project__item__content__skeleton">
            <div className="project__item__title__skeleton"></div>
            <div className="project__item__subtitle__skeleton"></div>
            <div className="project__item__subtitle__skeleton--primary"></div>
              {[...Array(8)].map((_, index) => (
                <div key={index} className="project__list__skeleton"></div>
              ))}
              <div className="project__list__skeleton--primary"></div>
            <div className="project__item__button__skeleton"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectItemSkeleton;